import { DuplicationsTable } from './duplications_table/DuplicationsTable'
import { MatchesTable } from './matches_table/MatchesTable'

export const DetailsTables = ({ user }) => {
  return (
    <>
      <DuplicationsTable duplicates={user.duplicates} />
      <MatchesTable matches={user.matches} user={user} />
      {/* {user.email || (user.phone && <SameContactInfoTable duplicates={user.sameContactInfo} />)} */}
    </>
  )
}
